import type { Step } from "react-joyride";

export const auditPlanDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າລາຍລະອຽດຜະແນການກວດສອບ! ຫນ້ານີ້ຈະສະແດງຂໍ້ມູນລາຍລະອຽດຂອງຜະແນການກວດສອບ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="plan-detail-header"]',
    content:
      "ນີ້ແມ່ນສ່ວນຫົວຂໍ້. ທ່ານຈະເຫັນຊື່ຜະແນການກວດສອບ, ສະຖານະ, ແລະປຸ່ມການກະທຳຕ່າງໆເຊັ່ນ: ແກ້ໄຂ, ດາວໂຫຼດ PDF, ຫຼືກັບໄປລາຍການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="plan-detail-basic-info"]',
    content:
      "ນີ້ແມ່ນຂໍ້ມູນພື້ນຖານ. ທ່ານຈະເຫັນລາຍລະອຽດຂອງຜະແນການກວດສອບເຊັ່ນ: ປະເພດ, ພະແນກ, ຄວາມຖີ່, ວັນທີກວດສອບຄັ້ງຖັດ, ແລະອື່ນໆ.",
    placement: "top",
  },
  {
    target: '[data-tourid="plan-detail-records"]',
    content:
      "ນີ້ແມ່ນລາຍການບັນທຶກການກວດສອບ. ທ່ານຈະເຫັນບັນທຶກການກວດສອບທັງໝົດທີ່ສ້າງຈາກແຜນນີ້. ກົດທີ່ບັນທຶກເພື່ອເບິ່ງລາຍລະອຽດ.",
    placement: "top",
  },
];
